import type { StateCreator } from "zustand";
import type { Infeasibility } from "@/types/roster-infeasibility";

/**
 * Roster Made는 생성하면서 상태전달하기 위해 사용
 */

export interface RosterMadeSlice {
  rosterMade: { status: "QUEUED" | "RUNNING" | "SUCCESS" | "FAILED" | null };
  rosterMadeError: string | null;
  rosterInfeasibility: Infeasibility | null;
  dismissedJobId: string | null;
  pollingTrigger: number; // 폴링 시작 트리거
  setRosterMade: (made: {
    status: "QUEUED" | "RUNNING" | "SUCCESS" | "FAILED" | null;
  }) => void;
  resetRosterMadeState: () => void;
  setRosterMadeError: (error: string | null) => void;
  setRosterInfeasibility: (infeasibility: Infeasibility | null) => void;
  setDismissedJobId: (jobId: string | null) => void;
  startPolling: () => void;
}

const initialState = {
  rosterMade: { status: null },
  rosterMadeError: null,
  rosterInfeasibility: null,
  dismissedJobId: null,
  pollingTrigger: 0,
};

export const createRosterMadeSlice: StateCreator<RosterMadeSlice> = (set) => ({
  ...initialState,
  setRosterMade: (made: {
    status: "QUEUED" | "RUNNING" | "SUCCESS" | "FAILED" | null;
  }) => set({ rosterMade: made }),
  setRosterMadeError: (error: string | null) => set({ rosterMadeError: error }),
  setRosterInfeasibility: (infeasibility: Infeasibility | null) =>
    set({ rosterInfeasibility: infeasibility }),
  setDismissedJobId: (jobId: string | null) =>
    set({ dismissedJobId: jobId }),
  resetRosterMadeState: () =>
    set((state) => ({
      ...initialState,
      dismissedJobId: state.dismissedJobId,
    })),
  startPolling: () => {
    set((state) => ({
      pollingTrigger: state.pollingTrigger + 1,
      rosterMade: { status: "QUEUED" },
      rosterInfeasibility: null,
      dismissedJobId: null,
    }));
  },
});
